import { ArrowBackIcon as ArrowBack, Typography } from "@iluvatar/ui-kit";

import { createFileRoute, useParams } from "@tanstack/react-router";

import { ErrorBoBoMessage } from "@/components/ErrorBoBoMessage";
import { ViewProfile } from "@/components/ViewProfile";
import { useChat } from "@/hooks/useChat";
import { useMatchedUser } from "@/hooks/useMatchedUser";
import DefaultLayout from "@/layout/default-page";

export const Route = createFileRoute("/profile/$matchId/$uid")({
  component: MatchProfile,
});

function MatchProfile() {
  const params: { matchId: string; uid: string } = useParams({ strict: false });
  const { chat, error } = useChat(params.matchId);
  const { data: partnerProfile, ...rest } = useMatchedUser(
    params.uid,
    chat?.communityId,
  );

  return (
    <DefaultLayout
      className={
        "profile-container ml-auto mr-auto [max-width:900px] flex flex-col [background:linear-gradient(180deg,_transparent_0%,_transparent_50%,_var(--color-background-default)_50%,_var(--color-background-default))] [@media(min-width:_900px)]:[--page-content-padding:42px] [@media(min-width:_900px)]:[padding-left:42px] [@media(min-width:_900px)]:[padding-right:42px] [&.profile-container--input]:[max-width:900px] [&.profile-container--input]:w-full [@media(max-width:_400px)]:[&.main-container]:[--page-content-padding:8px] [@media(max-width:_400px)]:[&.main-container]:[padding-left:8px] [@media(max-width:_400px)]:[&.main-container]:[padding-right:8px] mb-[76px] pb-[24px]"
      }
    >
      <ErrorBoBoMessage error={error || rest.error} />
      <div className="flex row mb-4">
        <Typography
          variant="subtitle2"
          onClick={() => {
            window.history.back();
          }}
          className="clickable cursor-pointer"
        >
          <ArrowBack className="[font-size:small]" /> back
        </Typography>
      </div>
      {partnerProfile && chat && (
        <ViewProfile
          communityId={chat.communityId}
          distance={
            partnerProfile?.distance
              ? `${partnerProfile?.distance}${partnerProfile?.distanceUnits}`
              : undefined
          }
          userId={partnerProfile?.uid}
          profile={partnerProfile?.profile}
          about={partnerProfile}
        />
      )}
    </DefaultLayout>
  );
}
